module.exports = {
      id: "new-label-usage",
      viewBox: "0 0 26 10",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#new-label",
      toString: function () {
        return this.url;
      }
    }